type PreloadCard = { photos?: { url?: string }[] };

const AHEAD_CARDS = 2;
const requested = new Set<string>();
// Держим ссылки на загружаемые картинки, чтобы браузер не отменил запрос раньше времени.
const inFlight = new Map<string, HTMLImageElement>();

/**
 * Какие картинки стоит скачать заранее: все фото текущей карточки (для просмотра
 * по свайпу) и первое фото следующих карточек (чтобы свайп показывал сразу).
 */
export function photoUrlsToPreload(
  cards: readonly PreloadCard[],
  currentIndex: number,
  ahead = AHEAD_CARDS,
): string[] {
  const urls: string[] = [];
  const push = (url: string | undefined) => {
    if (url?.startsWith('/') || url?.startsWith('https://')) urls.push(url);
  };
  for (const photo of cards[currentIndex]?.photos ?? []) push(photo.url);
  for (let offset = 1; offset <= ahead; offset += 1)
    push(cards[currentIndex + offset]?.photos?.[0]?.url);
  return [...new Set(urls)];
}

/** Начинает загрузку картинок в фоне; повторные адреса пропускаются. */
export function preloadImages(urls: readonly string[]): void {
  if (typeof Image === 'undefined') return;
  for (const url of urls) {
    if (requested.has(url)) continue;
    requested.add(url);
    const image = new Image();
    image.decoding = 'async';
    const release = () => {
      inFlight.delete(url);
    };
    image.onload = release;
    image.onerror = release;
    inFlight.set(url, image);
    image.src = url;
  }
}
